import React from 'react';
import { IOldIconProps } from './type';

const HeartLaFourche: React.FC<IOldIconProps> = ({
  width,
  height,
  color = '#ffcb03',
  ...props
}) => {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      viewBox="0 0 437.96 364.98"
      {...props}
    >
      <path
        d="M270.98 132.91c-26.64-16.13-51.71-18.65-74.92-12.46-10.42 2.78-20.53 8.36-28.51 15.79-4.21 3.92-6.13 5.93-8.94 9.4-5.66 6.97-10.26 14.55-14.21 22.59-.4.81-1.24 2.52-2.06 3.82-.95 1.5-1.51 1.71-2.53 1.25-2.54-1.15-6.91-2.88-9.26-4.22-1.3-.74-1.56-1.99-.3-5.76.27-.82 1.15-2.67 1.51-3.48 3.36-7.75 6.01-13.03 10.14-23.21s9.83-30.11 6.7-49.69c-7.65-34.05-38.77-49.4-71.26-45.83-51.99 5.71-97.41 68.68-68.12 160.93 26.27 82.73 27.58 84.03 13.66 148.49-2.32 10.75 12.56 17.21 17.59 13.31 37.03-28.69 72.92-37.92 108.35-38.53 40.25-.69 115.11-23.4 136.69-42.59 48.26-42.91 38.1-117.94-14.53-149.81z"
        style={{ fill: color }}
      />
      <path d="M437.26 103.29c-4.18-26.85-29.54-44.38-55.23-47.04-15.33-1.59-29.85 2.55-42.73 10 1.79-10.37 2.08-20.92.42-31.14-1.88-11.55-7.49-22.71-17.55-29.17-11-7.05-25.06-6.94-37.39-4.22-47.52 10.49-69.63 62.96-73.23 106.61-2.76 33.52 1.86 67.17-1.24 100.69-.53 5.68 5.23 10.55 10.55 10.55.93 0 1.79-.14 2.61-.35.07-.01.13-.01.2-.03 29.52-6.92 59.88-9 89.72-14.14 28.88-4.97 58.33-13.71 83.5-29.12 24.91-15.24 45.14-42.02 40.37-72.64zm-59.09 58.97c-22.63 11.77-47.2 18.56-72.25 22.77-24.48 4.11-49.29 6.32-73.69 10.89.89-21.78-.6-43.59-.47-65.39.12-21.34 1.79-43.07 10.48-62.84 6.99-15.91 17.77-31.06 33.09-39.82 12.49-7.15 35.61-12.78 42.05 4.68 3.68 9.96 2.66 21.68.66 31.88-2.54 12.93-7.42 24.91-14.46 36.02-7.33 11.56 10.69 21.83 18.22 10.65 12.01-17.83 31.67-34.11 54.23-34.07 18.08.03 38.01 11.58 40.7 30.73 3.52 24.99-18.79 44.22-38.56 54.5z" />
    </svg>
  );
};

export default HeartLaFourche;
